import { render, staticRenderFns } from "./CompanyProfile.main.vue?vue&type=template&id=40248b8c"
import script from "./CompanyProfile.main.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports